import App from "components/App";
import Home from "components/Home";
import MainLayout from "components/MainLayout";
import Story from "components/Story";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";

export enum Routes {
  BASE = "/",
  HOME = "/home",
  STORY = "/story/:storyuuid",
}

export enum AbsoluteRoutes {
  GO_BACK = "..",
  HOME = "home",
  STORY = "story",
}

const router = createBrowserRouter([
  {
    path: Routes.BASE,
    element: <MainLayout />,
    errorElement: <MainLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={Routes.HOME} replace={true} />,
      },
      {
        path: Routes.HOME,
        element: <Home />,
      },
      {
        path: Routes.STORY,
        element: <Story />,
      },
    ],
  },
]);

const BaseRoute = () => {
  return <RouterProvider router={router} />;
};

export default BaseRoute;
